import axios from "axios";
import { host } from "./utilities";

export const updateDomesticPaymentAxios =
  (uuid) =>
  (config, data = {}) =>
    axios.put(`${host()}/domestic-payment/${uuid}/status`, data, config);
